import Header from "../layout/Header";
import useNowPlayingMovies from "../../hooks/useNowPlayingMovies";
import MainContainer from "./MainContainer";
import SecondaryContainer from "./SecondaryContainer";
import usePopularMovies from "../../hooks/usePopularMovies";
import GptSearch from "../gpt/GptSearch";
import { useSelector } from "react-redux";
import useTopRatedMovies from "../../hooks/useTopRatedMovies";
import useUpcomingMovies from "../../hooks/useUpcomingMovies";
import useTrendingMovies from "../../hooks/useTrendingMovies";
import { RootState } from "../../store";
import Footer from "../layout/Footer";
import { motion, AnimatePresence } from "framer-motion";

const Browse = () => {
  const showGptSearch = useSelector((store: RootState) => store.gpt.showGptSearch);

  useNowPlayingMovies();
  usePopularMovies();
  useTopRatedMovies();
  useUpcomingMovies();
  useTrendingMovies();

  return (
    <div className="bg-black min-h-screen selection:bg-red-600 selection:text-white">
      <Header />
      <AnimatePresence mode="wait">
        <motion.div
          key={showGptSearch ? "gpt" : "browse"}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
        >
          {showGptSearch ? (
            <GptSearch />
          ) : (
            <main className="relative">
              <MainContainer />
              <div className="relative -mt-12 md:-mt-32 z-30">
                <SecondaryContainer />
              </div>
              <Footer />
            </main>
          )}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default Browse;
